<div class="sam-full-width">
   <div class="sam-form-flex-row">
      <ng-content></ng-content>
      <kendo-dropdownlist
         class="sam-full-width"
         [data]="possibleEditorTypes"
         [value]="selectedEditorType$ | async"
         [valuePrimitive]="false"
         [valueField]="'value'"
         [textField]="'value'"
         (selectionChange)="changeEditorType($event)"
      >
         <ng-template kendoDropDownListValueTemplate kendoDropDownListItemTemplate let-dataItem>
            {{ dataItem?.translationKey | translate }}
         </ng-template>
      </kendo-dropdownlist>
   </div>

   <div *ngIf="configurableEditorSettings$ | async as editorSettings" class="sam-form-flex-row sam-center">
      <ng-container *ngIf="(selectedEditorType$ | async).value === 'TEXT_EDITOR'">
         <!--    No settings available-->
      </ng-container>

      <ng-container *ngIf="(selectedEditorType$ | async).value === 'NUMBER_EDITOR'">
         <div class="sam-full-width">
            <div>
               <input
                  type="checkbox"
                  id="showDecimalsLabel"
                  [checked]="editorSettings.showDecimals"
                  (click)="showDecimalsChanged($event.currentTarget.checked, editorSettings)"
                  class="k-checkbox"
               />
               <label class="k-checkbox-label" for="showDecimalsLabel">{{
                  'common.types.editorType.settings.show_decimals_label' | translate
               }}</label>
            </div>
            <div>
               <input
                  type="checkbox"
                  id="showThousandSeparator"
                  [checked]="editorSettings.showThousandSeparator"
                  (click)="showThousandSeparatorChanged($event.currentTarget.checked, editorSettings)"
                  class="k-checkbox"
               />
               <label class="k-checkbox-label" for="showThousandSeparator">{{
                  'common.types.editorType.settings.show_thousand_separator_label' | translate
               }}</label>
            </div>
         </div>
      </ng-container>

      <ng-container *ngIf="(selectedEditorType$ | async).value === 'CHECK_BOX'">
         <div fxFlex="40">
            <label>{{ 'common.types.editorType.settings.checkbox_value_label' | translate }}</label>
         </div>
         <div class="k-form-field sam-form-control sam-form-control-full-width">
            <input
               (input)="checkboxValueChanged($event.target.value, editorSettings)"
               [value]="editorSettings.checkboxValue"
               fxFlex="1 1 auto"
               kendoTextBox
            />
         </div>
      </ng-container>

      <ng-container *ngIf="(selectedEditorType$ | async).value === 'RICH_TEXT_EDITOR'">
         <div class="sam-full-width">
            <input
               type="checkbox"
               id="isPlaintextModeLabel"
               [checked]="editorSettings.isPlaintextMode"
               (click)="isPlaintextModeChanged($event.currentTarget.checked, editorSettings)"
               class="k-checkbox"
            />
            <label class="k-checkbox-label" for="isPlaintextModeLabel">{{
               'common.types.editorType.settings.is_plaintext_mode_label' | translate
            }}</label>
         </div>
      </ng-container>

      <ng-container *ngIf="(selectedEditorType$ | async).value === 'SELECTOR'">
         <div class="sam-full-width">
            <p [style.margin]="0">{{ 'common.types.editorType.selector_value_information' | translate }}</p>
            <div class="k-form-field sam-form-control-full-width">
               <input
                  (input)="selectorValuesChanged($event.target.value, editorSettings)"
                  [value]="editorSettings.selectorValues"
                  fxFlex="1 1 auto"
                  kendoTextBox
               />
            </div>
         </div>
      </ng-container>
   </div>
</div>
